<template>
    <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
        <div class="file-container">
            <div class="file-label">{{label}}</div>
            <div class="file-action">
                <div class="file-filename">{{file.filename}}</div>
                <md-button class="md-raised md-primary file-button" @click="open_preview(file)"><i class="material-icons button-icon">visibility</i>{{translate(locale.preview)}}</md-button>
                <md-button class="md-raised md-primary file-button" @click="download(file)"><i class="material-icons button-icon">download</i>{{translate(locale.download)}}</md-button>
            </div>
        </div>
        <Preview :data="preview" v-if="preview.show" @close="close_preview()" />
    </div>
</template>
<script>
    import Preview from "../Preview.vue";
    export default {
    components: {
        Preview
    },
      props: {
        label: {}, file:{}
      },
      data() {
        return {
            preview: {
                show: false,
                name: this.label,
                url: this.config.cdn + "/preview/" + this.file.url
            }
        }
      },
      methods: {
        open_preview() {
            this.preview.show = true;
        },
        close_preview() {
            this.preview.show = false;
        }
      }
    }
</script>

<style scoped>
    .file-button {
        margin: 5px 5px;
    }
    .file-label {
        color: #353690;
    }
    .file-container {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .file-filename {
        margin-right: 10px;
        font-weight: bold;
        color: #353690;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .file-action {
        display: flex;
        align-items: center;
    }
    @media (max-width: 800px) {
        .file-label {
            width: 100% !important;
        }
        .file-container {
            flex-direction: column;
        }
        .file-action {
            width: 100%;
            display: flex;
            justify-content: space-between;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Review/FileLine.vue